
<template>
  <div class="value-adjustment">
    <v-container>
      <v-layout justify-center pt-3>
        <div class="adjustment-title pl-3 pt-1 pb-0">{{ title }}</div>

        <v-icon
          v-show="accessory != undefined"
          class="accessory"
          @click="accessorySelected"
        >
        {{ accessory }}
        </v-icon>

        <div 
          v-show="accessoryText != undefined"
          class="accessory-text"          
        >
          <a @click="accessorySelected">{{ accessoryText }}</a>
        </div>

        <div class="adjustment-value pr-3 pb-2 pt-0">
          <v-text-field
            :value="formattedValue"
            :suffix="prefix"
            :mask="mask"
            reverse
            single-line
            hide-details
            v-on:change="enteredValueDidChange"
            :disabled="isDisabled"
          ></v-text-field>
        </div>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'range-adjustment',
  data () {
    return {  
      enteredValue: this.value,
    }
  },

  props: [
    "ident",
    "title",
    "value",
    "prefix",
    "mask",
    "accessory",
    "accessoryText",
    "disabled"
  ],

  watch: {
    value: function(v) {
      this.enteredValue = v
    }
  },

  methods: {
    numberWithCommas(x) {
      var parts = x.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
    },
    enteredValueDidChange(v) {
      this.enteredValue =  Number(v.replace(/,/g, '')) || 0
      this.$emit("value-changed", { ident: this.ident, val: this.enteredValue })
    },
    accessorySelected() {
      this.$emit('accessory-selected', this)
    }
  },

  computed: {
    formattedValue() {
      return this.numberWithCommas(this.enteredValue)
    },
    isDisabled() {
      return this.disabled ? true : false
    },
  }
}

</script>


<style scoped>

.value-adjustment {
  font-size: 10pt;
  width: 100%;
  height: 100%;
  line-height: 1.85ch;
  text-align: center;
  top: 0;
  right: 0;
  position: relative;
}
.adjustment-title {
  text-align: left;
  font-size: 10pt;
  color:#262626;
  font-weight: 300;
  position: absolute;
  left: 0;
  top: 0;
}
.adjustment-value {
  text-align: right;
  font-size: 16pt;
  color:#4F78C4;
  font-weight: bold;
  position: absolute;
  width:100%;
  top: 4px;
  padding-left: 15px;
  padding-right: 10px;
}
.adjustment-slider {
  width: 100%;
}
.accessory {
  position: absolute;
  right: 20px;
  top: 0px;
  color: #4F78C4;
  z-index: 1000;
}
.accessory-text {
  position: absolute;
  right: 20px;
  top: 3px;
  color: #4F78C4;
}
a:link, a:visited, a:active {
  text-decoration: none;
}
a:hover {
  font-weight: bold;
}

@media only screen and (max-width: 768px) {
  .adjustment-value {
    width: 80%;
    font-size: 10pt;
  }
  .adjustment-title {
    font-size: 8pt;
  }
}

@media only screen and (max-height: 550px) {
  .adjustment-value {
    width: 80%;
    font-size: 10pt;
  }
  .adjustment-title {
    font-size: 8pt;
  }
}
</style>